var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"d-subject-page-custom"},[_c('PageHeader',_vm._b({},'PageHeader',{
			..._vm.$attrs,
			..._vm.$props,
		},false)),_vm._v(" "),(_vm.items && _vm.items.length)?_c('SubjectTabList',{staticClass:"mt-3xl",attrs:{"items":_vm.items}}):_vm._e(),_vm._v(" "),_c('BlockList',{staticClass:"mt-5xl",attrs:{"block-list":_vm.contentElements}}),_vm._v(" "),(!_vm.hideFeedback)?_c('FeedbackModule',{staticClass:"mt-7xl",attrs:{"feedback":_vm.feedback}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }